var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgWhiteLogo = function SvgWhiteLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 36,
    viewBox: "0 0 57 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H19.2383H20.1813C20.1813 0.377221 20.1813 0.565832 20.1813 0.754443C20.1813 11.8825 20.1813 22.8219 20.1813 33.9499C20.1813 34.5157 19.9927 34.7044 19.4269 34.7044C16.5977 34.7044 13.9572 34.7044 11.128 34.7044H10.3736V8.48748H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3646 26.5941C38.2721 26.5941 34.3113 22.4447 34.3113 17.5408C34.3113 12.4483 38.4607 8.48752 43.3646 8.48752C46.571 8.48752 49.4002 10.185 50.909 12.637L55.8129 5.65836C52.6065 2.45198 48.2685 0.377258 43.3646 0.377258C33.7455 0.377258 26.0125 8.1103 26.0125 17.7294C26.0125 27.3486 33.7455 35.0816 43.3646 35.0816C48.4571 35.0816 52.7952 33.0069 56.0015 29.6119L51.0977 22.0675C49.5888 24.708 46.571 26.5941 43.3646 26.5941Z",
    fill: "#F9DA87"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/whiteLogo.d333c986858876dc5eebbba28d285857.svg";